import { Component, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { Table, TableLazyLoadEvent } from "primeng/table";
import { PaginationParams } from "src/app/model/api/pagination-params";
import { AppState } from "src/app/store/app.reducer";
import { ItemsPagination } from "src/app/model/api/data-rest";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ConfirmationService } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { selecMtmaModules, selectCallUnitLog, selectCallUnitLogExport, selectCallUnitLogPagination, selectCurrentDevice, selectCurrentDeviceCommands, selectCurrentDeviceModel, selectCurrentDeviceStatus } from "src/app/store/device/device.selector";
import { DatePipe } from "@angular/common";
import { Device } from "src/app/model/device";
import * as DeviceActions from 'src/app/store/device/device.actions';
import { Observable, Subscription, debounceTime, filter } from "rxjs";
import { pageSortChange } from "src/app/services/table";
import { Command } from "src/app/model/command";
import { StandardDesignParameters, StandardDynamicComponent, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { selectDeviceTabIndex } from "src/app/store/home/home.selector";
import { DeviceModel } from "src/app/model/device-model";
import { isMtmacModel } from "src/app/conf/device-models";
import { CallUnitEvent, CallUnitExportLog } from "src/app/model/call-access-log";
import { CALL_ACCESS_LOG_DEFAULT_SORT_COLUMN, CALL_ACCESS_LOG_DEFAULT_SORT_COLUMN_DIRECTION, CALL_ACCESS_LOG_PAGE_DEFAULT_SIZE, CALL_ACCESS_LOG_PAGE_SIZE_OPTIONS, CALL_ACCESS_LOG_TABLE_HEADER } from "src/app/conf/call-access-log";
import { exportToCsv } from "src/app/modules/shared/utils/exportData";
import moment from "moment";
import { MtmaModule, MtmaModuleConfig } from "src/app/model/mtma-module";
import { MtmaModuleType } from "src/app/conf/mtma-module";
import { ToggleButtonChangeEvent } from "primeng/togglebutton";
import { DeviceStatus } from "src/app/model/device-status";

@Component({
	selector: 'app-call-access-log',
	templateUrl: './call-access-log.component.html',
	providers: [ConfirmationService, DialogService]
})

export class CallAccessLogComponent implements OnInit, OnDestroy {
	@ViewChild(Table)
	table: Table;


	deviceModel$: Observable<DeviceModel | undefined>;
	deviceModelSub: Subscription | undefined;
	tabIndex: number;
	tabIndex$: Observable<number | undefined>;
	tabIndexSub: Subscription | undefined;
	mtmaModules$: Observable<MtmaModule[] | undefined>;
	mtmaModulesSub: Subscription | undefined;
	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription | undefined;

	commands$: Observable<Command[] | undefined>;
	commandsSub: Subscription | undefined;

	logs: CallUnitEvent[];
	logs$: Observable<CallUnitEvent[] | undefined>;
	logsSub: Subscription | undefined;
	logsExport$: Observable<CallUnitEvent[] | undefined>;
	logsExportSub: Subscription | undefined;

	logsLoading: boolean;

	deviceModel: DeviceModel = new DeviceModel();
	currDevice: Device;
	currDevice$: Observable<Device | undefined>;
	currDeviceSub: Subscription | undefined;

	unitName: FormControl = new FormControl('');

	acceptButtonStyle: string;
	rejectButtonStyle: string;
	rejectButtonVisible: boolean;

	filter: '';
	filterGroup: FormGroup;
	filterSub: Subscription;

	ref: DynamicDialogRef | undefined;

	MAX_EXPORT_LOG = 10000;

	columns = CALL_ACCESS_LOG_TABLE_HEADER;
	paging$: Observable<ItemsPagination | undefined>;
	pagingSub: Subscription;
	pageSortSub: Subscription;
	paging: PaginationParams = {
		size: CALL_ACCESS_LOG_PAGE_DEFAULT_SIZE,
		page: 1,
		sort: CALL_ACCESS_LOG_DEFAULT_SORT_COLUMN,
		order: CALL_ACCESS_LOG_DEFAULT_SORT_COLUMN_DIRECTION,
	};
	pageSize: number = CALL_ACCESS_LOG_PAGE_DEFAULT_SIZE;
	pageSizeOptions = CALL_ACCESS_LOG_PAGE_SIZE_OPTIONS;
	resultLength: number;

	dateTransform: DatePipe;

	minDate: Date = new Date("1900-01-01");
	today = new Date();
	maxDate = new Date();
	typeSub: Subscription;
	resultSub: Subscription;

	callResult: any[];
	commands: Command[];
	configured: boolean;
	online: boolean;

	saving = false;

	expandedRows = {};

	screenWidth: number;
	MIN_WIDTH_COL6 = StandardDesignParameters.MIN_WIDTH_COL6;
	COLUMN_TITLE_MIN_WD = 647;


	enabledLog: boolean = false;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.today = new Date();
		this.maxDate = new Date();
		this.maxDate.setHours(23);
		this.maxDate.setMinutes(59);
		this.enabledLog = false;

		this.callResult = [
			{ value: 0, label: 'ACCEPTED' },
			{ value: 1, label: 'REJECTED' },
		];

		const endDate = new Date(this.today.getTime());
		const startDate = new Date(this.today.getTime());
		startDate.setDate(startDate.getDate() - 7);
		const curreLang = this.translate.currentLang;
		this.dateTransform = new DatePipe(curreLang);

		this.filterGroup = new FormGroup({
			'unitName': new FormControl(''),
			// 'callFilter': new FormControl(this.callResult[0].value),
			'startDateTime': new FormControl(startDate, Validators.required),
			'endDateTime': new FormControl(endDate, Validators.required),
		});
		this.subscribeAll();
		this.onResize();
	}

	ngOnDestroy(): void {
		this.deviceModelSub?.unsubscribe();
		this.logsSub?.unsubscribe();
		this.filterSub?.unsubscribe();
		this.pagingSub?.unsubscribe();
		this.currDeviceSub?.unsubscribe();
		this.tabIndexSub?.unsubscribe();
		this.mtmaModulesSub?.unsubscribe();
		this.deviceStatusSub?.unsubscribe();
	}

	initSelectors(): void {
		this.logs$ = this.store.select(selectCallUnitLog);
		this.currDevice$ = this.store.select(selectCurrentDevice);
		this.paging$ = this.store.select(selectCallUnitLogPagination);
		this.commands$ = this.store.select(selectCurrentDeviceCommands);
		this.tabIndex$ = this.store.select(selectDeviceTabIndex);
		this.deviceModel$ = this.store.select(selectCurrentDeviceModel);
		this.logsExport$ = this.store.select(selectCallUnitLogExport);
		this.mtmaModules$ = this.store.select(selecMtmaModules);
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
	}

	subscribeAll(): void {
		this.deviceStatusSub = this.deviceStatus$.subscribe(deviceState => {
			if (deviceState) {
				this.configured = deviceState.Configured === 0;
				this.online = deviceState.Online;
			}
		});
		this.deviceModelSub = this.deviceModel$.pipe(filter(dm => !!dm))
			.subscribe(deviceModel => {
				this.deviceModel = deviceModel;
				this.dispatchGetLogs();
			});
		this.logsSub = this.logs$.subscribe(
			(logs) => {
				this.logs = logs;
				this.logsLoading = false;
			});
		this.filterSub = this.filterGroup.valueChanges.pipe(
			debounceTime(500),
		).subscribe(() => {
			this.table?.reset();
			this.dispatchGetLogs();
		});
		this.pagingSub = this.paging$.subscribe((paging) => {
			if (paging !== undefined) {
				this.resultLength = paging.TotalCount;
				this.pageSize = paging.PageSize;
			}
		});
		this.currDeviceSub = this.currDevice$.subscribe(
			(device) => {
				this.currDevice = device
				this.dispatchGetLogs();
			});
		this.tabIndexSub = this.tabIndex$?.subscribe(
			async (tabIndex: number) => {
				this.tabIndex = tabIndex;
				this.dispatchGetLogs();
			});
		this.mtmaModulesSub = this.mtmaModules$.subscribe(mtmaModules => {
			const module = mtmaModules.filter(item => item.Type === MtmaModuleType.MTMAC)[0];
			if (module !== undefined && module.Config !== module.Config !== undefined && module.Config.EnableLogCall !== undefined) {
				this.enabledLog = module.Config.EnableLogCall === 1;
			} else {
				this.enabledLog = false;
			}
		});
	}

	get f(): any {
		return this.filterGroup.controls;
	}

	expandAll() {
		this.expandedRows = this.logs.reduce((acc, p) => (acc[p.Id] = true) && acc, {});
	}

	collapseAll() {
		this.expandedRows = {};
	}

	loadLogs(event: TableLazyLoadEvent) {
		this.paging = pageSortChange(this.paging, event);
		this.dispatchGetLogs();
	}

	translateData(str: string): string {
		let resStr = '';
		const fields = str.split('{{');
		for (const field of fields) {
			if (field.indexOf('}}') >= 0) {
				const toTranslate = field.split('}}');
				resStr = resStr + this.translate.instant('LOG_' + toTranslate[0]) + toTranslate[1];
			} else {
				resStr = resStr + field;
			}
		}
		return resStr;
	}

	isMtmaConnect(): boolean {
		return (this.deviceModel !== undefined && isMtmacModel(this.deviceModel.Id) && this.tabIndex >= 10); // TAB INDEX FOR MTMACONNECT CALLLOG IS 9
	}

	isSelectLogTab(): boolean {
		return this.isMtmaConnect();
	}

	getActionEventsLenght(actionEvents: any[]): boolean {
		return actionEvents.length > 0;
	}

	getCallsEventLenght(callsEvent: any[]): boolean {
		return callsEvent.length > 0;
	}

	refresh(): void {
		this.today = new Date();
		this.maxDate = new Date();
		this.maxDate.setHours(23);
		this.maxDate.setMinutes(59);
		const endDate = new Date(this.today.getTime());
		this.f.endDateTime.setValue(endDate);
	}

	dispatchGetLogs(): void {
		if (this.isSelectLogTab()) {
			this.logsLoading = true;
			const startDateTime = this.f.startDateTime.value;
			const endDateTime = this.f.endDateTime.value;
			if (this.currDevice !== undefined && startDateTime !== undefined && endDateTime !== undefined) {
				this.store.dispatch(DeviceActions.getCallUnitEventLog({
					deviceId: this.currDevice.Id,
					startDate: startDateTime,
					endDate: endDateTime,
					unitName: this.f.unitName.value,
					sort: this.paging.sort.toLowerCase(), order: this.paging.order, size: this.paging.size, page: this.paging.page
				}));
			}
		}
	}

	onSelectAccessType() {
		this.dispatchGetLogs();
	}

	onChangeSearch() {
		this.dispatchGetLogs();
	}

	onSelectPicker() {
		this.dispatchGetLogs();
	}

	getButtonInfo(btnId: number): string {
		if (btnId && btnId > 0) {
			if (btnId < 3) {
				return "MTMAC - " + btnId.toString();
			} else if (btnId < 99) {
				return "MTM8C - " + btnId.toString();
			} else if (btnId == 99) {
				return "MTMKB";
			} else {
				return "MTMDY";
			}
		}
		return "";
	}

	getLastResult(callsEvent: any[]): number {
		if (callsEvent && callsEvent.length > 0) {
			const lastIndex = callsEvent.length - 1;
			return callsEvent[lastIndex].Result;
		}
		return 0;
	}

	getResultInfo(result: number): string {
		if (result) {
			switch (result) {
				case 40:
					return this.translate.instant("CALL_NOT_TRANSMIT");
				case 41:
					return this.translate.instant("CALL_USER_RESPONSE");
				case 42:
					return this.translate.instant("CALL_USER_NOT_RESPONSE_NEW");
				case 43:
					return this.translate.instant("CALL_USER_NOT_ENABLED_ON_THIS_TIME");
				case 44:
					return this.translate.instant("CALL_USER_SWITCHED");
				case 45:
					return this.translate.instant("CALL_USER_BUSY");
				case 46:
					return this.translate.instant("CALL_USER_REJECTED_NEW");
				case 47:
					return this.translate.instant("CALL_USER_CANCELLED");
				default:
					return "";
			}
		}
		return "";
	}


	getResultColor(result: number): string {
		if (result) {
			switch (result) {
				case 41:
					return "success";
				case 42:
					return "danger";
				case 43:
					return "warning";
				case 44:
					return "warning";
				case 45:
					return "danger";
				case 46:
					return "danger";
				case 47:
					return "danger";
				default:
					return "warning";
			}
		}
		return "";
	}

	getActionResultInfo(result: number): string {
		if (result) {
			switch (result) {
				case 0:
					return this.translate.instant("NOT_EXECUTE");
				case 1:
					return this.translate.instant("EXECUTED");
				case 20:
					return this.translate.instant("AUTOMATION_OFFLINE");
				case 21:
					return this.translate.instant("AUTOMATION_ERROR");
				default:
					return this.translate.instant("NOT_EXECUTE");
			}
		}
		return "";
	}

	getActionResultColor(result: number): string {
		if (result) {
			switch (result) {
				case 0:
					return "danger";
				case 1:
					return "success";
				default:
					return "danger";
			}
		}
		return "";
	}

	getDate(date: string): Date {
		const dateChange = moment.utc(date)
		return dateChange.toDate();
	}

	enableLog(event: ToggleButtonChangeEvent): void {
		const module = new MtmaModuleConfig();
		if (event.checked) {
			module.EnableLogCall = 1;
		} else {
			module.EnableLogCall = 0;
		}
		this.store.dispatch(DeviceActions.editParamMtmaModule({ module: module }));
	}

	//EXPORT
	exportLimitWarning(): void {
		this.acceptButtonStyle = "p-button-secondary";
		this.rejectButtonVisible = false;
		this.confirmationService.confirm({
			header: this.translate.instant('WARNING_EXPORT_LOG_TITLE'),
			message: this.translate.instant('WARNING_EXPORT_LOG_MESSAGE'),
			acceptLabel: this.translate.instant('CLOSE'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => { },
			reject: () => { }
		});
	}

	exportToCsv() {
		if (this.resultLength > this.MAX_EXPORT_LOG) {
			this.exportLimitWarning();
		} else {
			this.saving = true;
			const startDateTime = this.f.startDateTime.value;
			const endDateTime = this.f.endDateTime.value;
			const unitName = this.f.unitName.value;
			if (this.currDevice !== undefined && startDateTime !== undefined && endDateTime !== undefined) {
				this.logsLoading = true;
				this.store.dispatch(DeviceActions.getCallUnitLogExport({
					deviceId: this.currDevice.Id,
					startDate: startDateTime,
					endDate: endDateTime,
					unitName: unitName,
					sort: this.paging.sort.toLowerCase(), order: this.paging.order
				}));
			}
			this.logsExportSub = this.logsExport$.subscribe(
				(logs) => {
					if (logs !== undefined && logs.length > 0) {
						const map = new Map();
						map.set("EventDate", this.translate.instant('EVENT_DATE'));
						map.set("Button", this.translate.instant('BUTTON'));
						map.set("UnitName", this.translate.instant('UNITS'));
						map.set("Result", this.translate.instant('CALL_STATUS'));
						map.set("EventDateCallAccess", this.translate.instant('EVENT_CALL_DATE'));
						map.set("Source", this.translate.instant('CONTACT'));
						map.set("Code", this.translate.instant('PHONE_NUMBER'));
						map.set("ResultCallAccess", this.translate.instant('CALL_STATUS'));
						map.set("EventDateAction", this.translate.instant('EVENT_ACTION_DATE'));
						map.set("CodeDtmf", this.translate.instant('DTMF_CODE'));
						map.set("ActionDtmf", this.translate.instant('DTMF_ACTION'));
						map.set("ResultAction", this.translate.instant('EXECUTION_STATE'));
						const data = this.prepareDataForLogs(logs);
						exportToCsv(data, 'exportData', map);
						this.logsExportSub?.unsubscribe();
						this.logsLoading = false;
						this.store.dispatch(DeviceActions.resetCallUnitLogExport());
						this.saving = false;
					}
				}
			)
		}
	}

	prepareDataForLogs(logs: CallUnitEvent[]): CallUnitExportLog[] {
		const list = [];
		for (const log of logs) {
			list.push(this.prepareDataForFirstTableLog(log));
			const callsEvent = log["CallsEvent"];
			if (callsEvent.length > 0) {
				callsEvent.forEach(callEvent => {
					list.push(this.prepareDataForSecondTableLog(callEvent));
					const actionEvents = callEvent["ActionEvents"];
					if (actionEvents.length > 0) {
						actionEvents.forEach(actionEvent => {
							list.push(this.prepareDataForThirdTableLog(actionEvent));
						});
					}
				});
			}
		}
		return list;
	}

	prepareDataForFirstTableLog(log: CallUnitEvent): CallUnitExportLog {
		const logExport = new CallUnitExportLog();
		logExport.EventDate = moment.utc(log.EventDate).format('DD-MM-yyyy HH:mm:ss');
		logExport.Button = this.getButtonInfo(log.ButtonId);
		logExport.UnitName = log.UnitName;
		logExport.Result = this.getResultInfo(this.getLastResult(log["CallsEvent"]));
		return logExport;
	}

	prepareDataForSecondTableLog(callEvent): CallUnitExportLog {
		const logExport = new CallUnitExportLog();
		logExport.EventDateCallAccess = moment.utc(callEvent.EventDate).format('DD-MM-yyyy HH:mm:ss');
		logExport.Source = callEvent.Source;
		logExport.Code = callEvent.Code;
		logExport.ResultCallAccess = this.getResultInfo(callEvent.Result);
		return logExport;
	}

	prepareDataForThirdTableLog(actionEvent): CallUnitExportLog {
		const logExport = new CallUnitExportLog();
		logExport.EventDateAction = moment.utc(actionEvent.EventDate).format('DD-MM-yyyy HH:mm:ss');
		logExport.CodeDtmf = actionEvent.DtmfCode;
		logExport.ActionDtmf = actionEvent.Source;
		logExport.ResultAction = this.getActionResultInfo(actionEvent.Result);
		return logExport;
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	underTablet(): boolean {
		return StandardPageLayout.underTablet(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}

	col3ResponsiveStd(): string {
		return StandardPageLayout.col3ResponsiveStd(this.screenWidth);
	}

	col4Responsive(): string {
		return StandardPageLayout.col4ResponsiveStd(this.screenWidth);
	}

	col3Responsive(): string {
		return (this.screenWidth >= StandardDesignParameters.MIN_WIDTH_MX7_LATER) ? "col-3 px-5" : (this.screenWidth >= StandardDesignParameters.MIN_WIDTH_COL6) ? 'col-3' : 'col-6';
	}

	disableCol(): boolean {
		return this.screenWidth < StandardDesignParameters.MIN_WIDTH_MX7_LATER;
	}

	col6Responsive(): string {
		return StandardPageLayout.col6ResponsiveNoPadding(this.screenWidth);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicAutocomplete(): string {
		return StandardDynamicComponent.dynamicAutocomplete(this.screenWidth);
	}
}